import { UserStatus } from './user-info-card';

const AVATAR_PALETTE = [
  '#F07B06',
  '#F02406',
  '#FF3B73',
  '#8656F0',
  '#0553F0',
  '#05A1F0',
  '#C5690C',
  '#C4250D',
  '#B80CC4',
  '#6E0CC4',
  '#4670DB',
  '#0CC4C4',
  '#53A118',
  '#9FC40C',
  '#AE6559',
  '#875AAD',
  '#5A76AD',
  '#5A99AD',
  '#5AAD76',
  '#9DAD5A'
];

const INACTIVE_AVATAR_COLOR = '#8C8C8C';

const INACTIVE_USER_STATUSES: UserStatus[] = ['FormerUser', 'AccountRemoved', 'UserBlockedInApartment'];

export function avatarColor(seed: string | null | undefined, status?: UserStatus): string {
  if (!!status && INACTIVE_USER_STATUSES.includes(status)) {
    return INACTIVE_AVATAR_COLOR;
  }
  if (!seed) {
    return AVATAR_PALETTE[0];
  }

  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) | 0;
  }

  return AVATAR_PALETTE[Math.abs(hash) % AVATAR_PALETTE.length];
}
